import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';

import { WindowAppIdentifier } from '@app/auth/auth.model';

import { ContactsComponent } from './contacts/contacts.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [CommonModule, ContactsComponent]
})
export class FooterComponent implements OnInit, AfterViewInit {
  isApp = false;
  @ViewChild('defaultHideInApp', { static: true })
  defaultHideInApp!: ElementRef;
  constructor(
    private router: Router,
    private renderer: Renderer2
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.isApp = sessionStorage.getItem('platform') === 'APP';
      }
    });
  }

  ngOnInit(): void {
    this.hideFooter();
  }

  ngAfterViewInit(): void {
    this.isApp = sessionStorage.getItem('platform') === 'APP';
  }

  hideFooter() {
    if (window[WindowAppIdentifier] !== undefined) {
      this.renderer.setStyle(
        this.defaultHideInApp.nativeElement,
        'display',
        'none'
      );
    }
  }
}
